import { Alert } from '@neo/primitives/alert'
import { SubAccountsSelect } from 'v2/api-console/shared/components/subaccount-form-select'
import { useSubaccountTagControl } from './agent-subaccount-warnings'

interface AgentSubaccountControlProps {
  currentSubAuthId: string | null
  disabled?: boolean
}

/**
 * The Sub Account tag control on the agent Settings tab. Writes the tag into
 * agentSettings; the main Save/Publish button persists it in the wholesale flow
 * save, and config-service validates a change server-side (parent check). A staged
 * tag shows an inline attribution warning above the dropdown.
 */
export const AgentSubaccountControl = (props: AgentSubaccountControlProps) => {
  const { value, showLinkWarning, linkWarning, onSelect } = useSubaccountTagControl(props)
  const { disabled = false } = props

  return (
    <div className="space-y-3 pt-2" data-testid="control-agent-subaccount">
      {showLinkWarning && (
        <div data-testid="warning-subaccount-link">
          <Alert variant="warning" title={linkWarning.title} content={linkWarning.content} />
        </div>
      )}
      <div className="grid grid-cols-2 gap-4">
        <SubAccountsSelect
          label="Sub Account"
          value={value}
          onChange={onSelect}
          disabled={disabled}
          // A disabled subaccount must not be offered for a NEW tag, but an
          // already-tagged (now-disabled) one still shows its name (see prop doc).
          excludeDisabled
        />
      </div>
    </div>
  )
}
